<template>
  <div class="case-study-preview u-w8of12 u-marg-l-4of12 u-bg-white u-pad-xl u-w12of12--sm u-marg-l-0--sm u-z-middle">
    <div class="u-row u-middle u-marg-b-lg">
      <h3 class="t-h3 u-black u-inline-block u-pad-r-md">
        {{data.title}}
      </h3>
      <div>
        <app-button :to="{...$local('Project'), params: {slug: data.slug }}" :isSmall="true">
          <span class="t-text--xsmall">
            Voir le case study
          </span>
        </app-button>
      </div>
    </div>
    <div class="u-row u-top">
      <div class="u-w3of12">
        <p>Year</p>
        <p class="t-text--big t-bold">{{data.brightYear}}</p>
      </div>
      <div class="u-w3of12 u-marg-r-1of12">
        <p>Client</p>
        <p class="t-text--big t-bold">{{data.brightClient}}</p>
      </div>
      <div class="u-w3of12">
        <p>Platform</p>
        <p class="t-text--big t-bold">{{data.brightPlateform}}</p>
      </div>
    </div>
    <p class="t-text u-marg-y-lg u-w10of12 u-marg-l-2of12">{{data.brightDescriptionPreview}}</p>
    <app-image v-if="data.image.length" :id="data.image[0].id" :src="data.image[0].url" :width="1000" class="u-w12of12" alt="Project picture" />
  </div>
</template>

<script>
import AppButton from '@/components/common/AppButton'

export default {
  components: {
    AppButton
  },

  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="stylus">

.case-study-preview
  min-height 100vh
  position absolute
  top 0
  right 0

</style>